<template>
	<!-- header -->
	<header id="header">
		<div class="hInner header_aiorderInput subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to="#"></router-link></div>
				<div class="hLine"></div>
				<div class="hName">AI 기공주문</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="ai_order">
		<div class="content aiorder_match">
			<div class="contIn">
				<form ref="form_aiorder_match" id="form_aiorder_match" :action="`${SERVER_URL}/api/app/matching`"
					@submit.prevent="form_aiorder_match_submit()" method="post" autocomplete="off">
					<div class="aiorder_matchList">
						<div class="sub_tit">{{ other_type }} 선택</div>
						<div class="match_search">
							<input id="search" type="text" class="live-search-box" placeholder="검색어를 입력해주세요">
						</div>

						<ul :class="HZwrapper" class="match_list">
							<li v-for="(item, index) in items" :key="index"
								:class="[HZlines, { select: hos_id === item.partner.mb_boss_id }]"
								:data-idx="item.partner.mb_boss_id" data-show="Y"
								@click="goto_url(`/aiorder_step2/${item.partner.mb_boss_id}`)"
								:data-search-term="item.partner.mb_nick + item.partner.mb_busi_addr + item.partner.mb_tel + '&nbsp;/&nbsp;' + item.partner.mb_hp">
								<input type="radio" class="match_checkbox" :value="item.partner.mb_boss_id"
									:checked="hos_id === item.partner.mb_boss_id" style="display: none;">
								<div class="match_img">
									<img v-if="item.partner.mb_icon"
										:src="`${SERVER_URL}/images/member/${item.partner.mb_icon}`"
										style="max-width:100%;">
									<img v-else src="/img/common/profile_ex.png" style="max-width:100%;">
								</div>
								<div class="match_info">
									<p class="match_tit">{{ item.partner.mb_nick }}</p>
									<p class="match_txt">{{ item.partner.mb_busi_addr }}</p>
									<p class="match_txt">{{ item.partner.mb_tel }}&nbsp;/&nbsp;{{ item.partner.mb_hp }}
									</p>
								</div>
							</li>
						</ul>

						<div class="nomatch_list">
							<p class="icon_notice_g"></p>
							<p>검색 결과가 존재하지 않습니다.</p>
						</div>
					</div>
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as step1js from '@/components/utils/setting_step1';

const route = useRoute();
const router = useRouter();

const today = moment().format('YYYY-MM-DD');

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

const items = ref([]); // 아이템 리스트

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';
const HZperPage = 10;
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / HZperPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * HZperPage;
	const end = start + HZperPage;
	return items.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const goto_url = (url) => {
	router.push(url);
}

onMounted(async () => {
	commonjs.DOMLoaded(); // 240724 헤더가 없는 페이지는 불러와야됨
	step1js.DOMLoaded();

	await getModels();

console.log('매칭 가능수', unmatchedCount.value);
	if (unmatchedCount.value < 1) {
		commonjs.formSwal('거래처 없음', '기공 주문을 할 거래처가 없습니다.', 'popup', 'error');
	}
});

const unmatchedCount = computed(() => {
	return items.value.filter(item => !((item?.partner && item.partner.mb_boss_id === globaljs.mb_boss_id) || item?.unmatched?.[0]?.status === null)).length;
});

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type);
	params.append('mb_boss_id', globaljs.mb_boss_id);
	//params.append('mb_level', globaljs.mb_level);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/matching`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
	} catch (error) {
console.error('Error getModels:', error);
	}
}
</script>